










































































































































































import { Vue, Component } from 'vue-property-decorator'
import PStorage, { KEYBIND_GLOBAL_SEARCH } from '@/util/PStorage'
import { Mutation, State } from 'vuex-class'
import {
    UI_SET_DRAG_DROP_VAULTS,
    UI_SET_SHOW_TOOLTIPS,
    UI_SET_THEME,
    UI_SET_DARKNESS
} from '@/store/ui/constants'
import { RootState } from '@/store/types'
import { isElectron } from '@/util/Helpers'

import SettingsHeader from '../components/SettingsHeader.vue'
import SettingsSection from '../components/SettingsSection.vue'
import SettingsRow from '../components/SettingsRow.vue'
import KeybindInput from '../components/KeybindInput.vue'

/* eslint-disable indent */
@Component({
    name: 'interface-panel',
    components: { SettingsHeader, SettingsSection, SettingsRow, KeybindInput }
})
/* eslint-enable indent */
export default class InterfacePanel extends Vue {
    keybindGlobalSearch: string = PStorage.getOrDefault(KEYBIND_GLOBAL_SEARCH, 'CmdOrCtrl+\\')

    @State((state: RootState) => state.ui.dragDropVaults)
    dragDropVaults!: boolean

    /**
     * Application darkness level
     */
    @State((state: RootState) => state.ui.darkness)
    darkness!: string
    @Mutation(UI_SET_DARKNESS)
    setDarkness!: (darkness: string) => void

    /**
     * Application colour theme
     */
    @State((state: RootState) => state.ui.theme)
    theme!: string
    @Mutation(UI_SET_THEME)
    setTheme!: (theme: string) => void

    @Mutation(UI_SET_DRAG_DROP_VAULTS)
    setDragAndDropVaults!: (dragDropVaults: boolean) => void

    @State((state: RootState) => state.ui.showTooltips)
    showTooltips!: boolean

    @Mutation(UI_SET_SHOW_TOOLTIPS)
    setShowTooltips!: (showTooltips: boolean) => void

    isElectron(): boolean {
        return isElectron()
    }

    updateKeybindGlobalSearch(value: string): void {
        if (!this.isElectron() || value.endsWith('+')) return
        PStorage.set(KEYBIND_GLOBAL_SEARCH, value)
        this.keybindGlobalSearch = value
        window.ipc.send('change-keybind-global-search', value)
    }
}
